import Vue from 'vue'
import Router from 'vue-router'
import store from '@/commons/store'
import guards from '@/guards'
import NaoAutorizado from '@/views/nao-autorizado/NaoAutorizado.vue'
import LicitacaoBusca from './views/licitacao/busca/LicitacaoBusca'
import LicitacaoNovo from './views/licitacao/detalhe/orgao/LicitacaoNovo'

import LicitacaoAtualizacao from './views/licitacao/detalhe/orgao/LicitacaoAtualizacao.vue'

import LicitacaoAtualizacaoDadosGerais from './views/licitacao/detalhe/orgao/LicitacaoAtualizacaoDadosGerais'

import CredenciamentoAtualizacaoDadosGerais
    from './views/credenciamento/detalhe-credenciamento/orgao/CredenciamentoAtualizacaoDadosGerais.vue'

import LicitacaoAtualizacaoEdital from './views/licitacao/detalhe/orgao/LicitacaoAtualizacaoEdital'

import CredenciamentoAtualizacaoEdital
    from './views/credenciamento/detalhe-credenciamento/orgao/CredenciamentoAtualizacaoEdital.vue'

import LicitacaoAtualizacaoLotesItens from './views/licitacao/detalhe/orgao/LicitacaoAtualizacaoLotesItens'

import CredenciamentoAtualizacaoLotesItens
    from './views/credenciamento/detalhe-credenciamento/orgao/CredenciamentoAtualizacaoLotesItens.vue'

import LicitacaoEsclarecimentoImpugnacao
    from './views/licitacao/detalhe/orgao/EsclarecimentoImpugnacao/LicitacaoEsclarecimentoImpugnacao'

import CredenciamentoEsclarecimentoImpugnacao
    from './views/credenciamento/detalhe-credenciamento/orgao/EsclarecimentoImpugnacao/CredenciamentoEsclarecimentoImpugnacao.vue'

import LicitacaoRecursoContrarrazao
    from './views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazao'

import CredenciamentoRecursoContrarrazao
    from './views/credenciamento/detalhe-credenciamento/orgao/recursocontrarrazao/CredenciamentoRecursoContrarrazao.vue'

import LicitacaoFornecedor from './views/licitacao/detalhe/fornecedor/LicitacaoFornecedor'

import CredenciamentoFornecedor from './views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoFornecedor.vue'

import LicitacaoFornecedorDadosGerais from './views/licitacao/detalhe/fornecedor/LicitacaoFornecedorDadosGerais'

import CredenciamentoFornecedorDadosGerais
    from './views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoFornecedorDadosGerais.vue'

import LicitacaoFornecedorEdital from './views/licitacao/detalhe/fornecedor/LicitacaoFornecedorEdital'

import CredenciamentoFornecedorEdital
    from './views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoFornecedorEdital.vue'

import LicitacaoFornecedorItens from './views/licitacao/detalhe/fornecedor/LicitacaoFornecedorItens'

import CredenciamentoFornecedorItens
    from './views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoFornecedorItens.vue'

import LicitacaoFornecedorProposta from './views/licitacao/detalhe/fornecedor/proposta/LicitacaoFornecedorProposta'

import CredenciamentoFornecedorProposta
    from './views/credenciamento/detalhe-credenciamento/fornecedor/proposta/CredenciamentoFornecedorProposta.vue'

import LicitacaoFornecedorDocumentos from './views/licitacao/detalhe/fornecedor/LicitacaoFornecedorDocumentos'

import LicitacaoFornecedorReadequacaoProposta
    from './views/licitacao/detalhe/fornecedor/proposta/LicitacaoFornecedorReadequacaoProposta'

import CredenciamentoFornecedorDocumentos
    from './views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoFornecedorDocumentos.vue'

import LicitacaoFornecedorEsclarecimentoImpugnacao
    from './views/licitacao/detalhe/fornecedor/LicitacaoFornecedorEsclarecimentoImpugnacao'

import CredenciamentoFornecedorEsclarecimentoImpugnacao
    from './views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoFornecedorEsclarecimentoImpugnacao.vue'


import RedirecionaEditarUsuario from './views/configuracao/perfil/RedirecionaEditarUsuario'
import Configuracao from './views/configuracao/Configuracao'
import ComissaoBusca from './views/configuracao/comissao/busca/ComissaoBusca'
import ComissaoNovo from './views/configuracao/comissao/detalhe/ComissaoNovo'
import ComissaoAtualizacao from './views/configuracao/comissao/detalhe/ComissaoAtualizacao'
import UsuarioBusca from './views/configuracao/usuario/busca/UsuarioBusca'
import UsuarioNovo from './views/configuracao/usuario/detalhe/UsuarioNovo'
import UsuarioDetalhe from './views/configuracao/usuario/detalhe/UsuarioDetalhe'
import MinhasLicitacoes from './views/minhas-licitacoes/MinhasLicitacoes'
import SelecionarDominio from './views/selecionar-dominio/SelecionarDominio'
import TelaPlanos from './views/planos/telaPlanos/TelaPlanos'
import PlanoFaturas from './views/planos/planoFaturas/PlanoFaturas'
import SelecionarTipoPagamento from './views/planos/pagamento/SelecionarTipoPagamento'
import ComissaoVisualizacao from '@/views/configuracao/comissao/detalhe/ComissaoVisualizacao.vue'


import TimelineEventosPosPublicacao from './views/licitacao/detalhe/orgao/components/TimelineEventosPosPublicacao'

import CredenciamentoTimelineEventosPosPublicacao
    from './views/credenciamento/detalhe-credenciamento/orgao/components/CredenciamentoTimelineEventosPosPublicacao.vue'

import DocumentosVirtualizacao from "@/views/licitacao/detalhe/orgao/documentosvirtualizacao/DocumentosVirtualizacao";
import Desentranhamento from "@/views/licitacao/detalhe/orgao/documentosvirtualizacao/Desentranhamento";
import CompararHash from '@/views/licitacao/detalhe/orgao/protocolos/CompararHash';
import ProtocoloSelecionarBusca from '@/views/licitacao/detalhe/orgao/protocolos/ProtocoloSelecionarBusca.vue'
import ProtocoloBusca from '@/views/licitacao/detalhe/orgao/protocolos/ProtocoloBusca.vue'
import ProtocoloDetalhe from '@/views/licitacao/detalhe/orgao/protocolos/ProtocoloDetalhe'
import Novidades from "@/views/sobre/Novidades";
import Sobre from "@/views/sobre/Sobre";
import Roadmap from "@/views/sobre/Roadmap";
import Sugestoes from "@/views/sobre/Sugestoes";
import IntegracaoIPM from "@/views/integracoes/IntegracaoIPM";
import SituacaoIntegracoes from "@/views/configuracao/sistema/SituacaoIntegracoes";
import TermosConfiguracao from "@/views/configuracao/termos/TermosConfiguracao";
import TermoNovo from "@/views/configuracao/termos/TermoNovo";
import TermoAtualizacao from "@/views/configuracao/termos/TermoAtualizacao";
import ManualLicitacaoServidor from "@/views/configuracao/manual-do-comprador/ManualLicitacaoServidor";
import ManualLicitacaoLicitante from "@/views/configuracao/manual-do-fornecedor/ManualLicitacaoLicitante";

import CredenciamentoAtualizacao from "@/views/credenciamento/detalhe-credenciamento/orgao/CredenciamentoAtualizacao.vue";
import CredenciamentoAtualizacaoSelecaoParticipantes
    from "@/views/credenciamento/detalhe-credenciamento/orgao/CredenciamentoAtualizacaoSelecaoParticipantes.vue";

import AnaliseDocumentacaoCredenciamento
    from '@/views/credenciamento/detalhe-credenciamento/analise-documentacao-credenciamento/AnaliseDocumentacaoCredenciamento.vue'
import CredenciamentoFornecedorResultado
    from "@/views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoFornecedorResultado.vue";
import DesinscricaoConfirmacao
    from "@/views/licitacao/desinscricao-email-licitacao-fornecedor/DesinscricaoConfirmacao.vue";
import Consultas from '@/views/consultas/Consultas.vue'
import ConsultasListagem from '@/views/consultas/listagem/ConsultasListagem.vue'
import ConsultasDetalhesDadosLicitacao from '@/views/consultas/detalhe/dados-licitacao/ConsultasDetalheDadosLicitacao'
import ConsultasDetalheEsclarecimentoImpugnacao
    from '@/views/consultas/detalhe/esclarecimento-impugnacao/ConsultasDetalheEsclarecimentoImpugnacao'
import ConsultasDetalheDocumentosFornecedor
    from '@/views/consultas/detalhe/documentos-fornecedor/ConsultasDetalheDocumentosFornecedor'
import CredenciamentoExecucao from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/CredenciamentoExecucao.vue";
import CredenciamentoExecucaoFornecedor
    from "@/views/credenciamento/detalhe-credenciamento/fornecedor/CredenciamentoExecucaoFornecedor.vue";
import AnaliseDemandaCredenciamentoFornecedor
    from "@/views/credenciamento/detalhe-credenciamento/fornecedor/execucao/analise/AnaliseDemandaCredenciamentoFornecedor.vue";
import AnaliseDemandaCredenciamento
    from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/analise/AnaliseDemandaCredenciamento.vue";
import CredenciamentoBusca from "@/views/credenciamento/busca-credenciamento/CredenciamentoBusca.vue";
import CredenciamentoDocumentosVirtualizacao
    from "@/views/credenciamento/detalhe-credenciamento/orgao/documentosvirtualizacao/CredenciamentoDocumentosVirtualizacao.vue";
import CredenciamentoDesentranhamento
    from "@/views/credenciamento/detalhe-credenciamento/orgao/documentosvirtualizacao/Desentranhamento.vue";
import Edocs from "@/views/licitacao/detalhe/orgao/edocs/Edocs.vue";
import LicitacaoAtualizacaoAcoesOcorrenciasEnviar
    from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesOcorrenciasEnviar.vue";
import LicitacaoEsclarecimentoUsuarioConvidado
    from "@/views/licitacao/detalhe/orgao/EsclarecimentoImpugnacao/LicitacaoEsclarecimentoUsuarioConvidado.vue";
import LicitacaoImpugnacaoUsuarioConvidado
    from "@/views/licitacao/detalhe/orgao/EsclarecimentoImpugnacao/LicitacaoImpugnacaoUsuarioConvidado.vue";
import LicitacaoAtualizacaoAcoesOcorrenciasProtocolo
    from "@/views/licitacao/detalhe/orgao/acoes/LicitacaoAtualizacaoAcoesOcorrenciasProtocolo.vue";
import RedirectPage from "@/views/integracoes/RedirectPage.vue";
import RelatoriosPersonalizados from "@/views/relatorios/RelatoriosPersonalizados.vue";

Vue.use(Router)

const hasAuthority = (authority) => {
    const user = store.state.loki.user.authorities;
    const authorities = user ? user.authorities : [];
    return authorities ? authorities.includes(authority) : false;
};

const router = new Router({
    routes: [
        {
            path: '/',
            beforeEnter: (to, from, next) => {
                if (hasAuthority('Credenciamento.Visualizar') || hasAuthority('Credenciamento.Editar')) {
                    next({ name: 'credenciamentoBusca' });
                } else {
                    next({ name: 'licitacaoBusca' });
                }
            }
        },
        {
            path: '/401',
            name: 'PaginaNaoAutorizado',
            component: NaoAutorizado
        },
        {
            path: '/planos',
            name: 'planos',
            component: TelaPlanos,
            meta:{
                independente: true
            }
        },
        {
            path: '/planos/:idPlano/selecionarPagamento',
            name: 'selecionarPagamento',
            component: SelecionarTipoPagamento,
            meta:{
                independente: true
            }
        },
        {
            path: '/selecionarDominio',
            name: 'selecionarDominio',
            component: SelecionarDominio,
            meta: { independente: true }
        },
        {
            path: '/redirect=:rotaDestino',
            name: 'redirectPregao',
            component: RedirectPage,
            meta:{
                independente: true
            }
        },
        {
            path: '/perfil',
            name: 'RedirecionarEditarUsuario',
            component: RedirecionaEditarUsuario
        },
        {
            path: '/planoFaturas',
            name: 'PlanoFaturas',
            component: PlanoFaturas,
            meta:{
                page:{
                    title: 'Plano e Faturas',
                    subtitle: 'Lista geral de faturas'
                }
            }
        },
        {
            path: '/licitacoes',
            name: 'licitacaoBusca',
            component: LicitacaoBusca,
            meta: {
                menu: {
                    title: 'Licitação',
                    icon: 'format_list_bulleted'
                },
                page: {
                    title: 'Licitação',
                    subtitle: 'Lista geral de licitações disponíveis'
                },
                authorities: ['Licitacao.Visualizar']
            },
        },
        {
            path: '/credenciamentos',
            name: 'credenciamentoBusca',
            component: CredenciamentoBusca,
            meta: {
                menu: {
                    title: 'Credenciamento',
                    icon: 'format_list_bulleted'
                },
                page: {
                    title: 'Credenciamento',
                    subtitle: 'Lista geral de credenciamento disponíveis'
                },
                authorities: ['Credenciamento.Visualizar', 'Credenciamento.Fornecedor']
            },
        },
        {
            path: '/licitacoes/msg=:tipo',
            name: 'licitacaoBuscaMsg',
            component: LicitacaoBusca,
            meta: {
                page: {
                    title: 'Licitação',
                    subtitle: 'Lista geral de licitações disponíveis'
                }
            }
        },
        {
            path: '/licitacoes/cancelar-recebimento-email-licitacao/:id',
            name: 'deinscricaoConfirmacao',
            component: DesinscricaoConfirmacao,
            meta: {
                page: {
                    title: 'Licitação',
                    subtitle: 'Confirmar desinscrição dos e-mails para a licitação'
                }
            }
        },
        {
            path: '/licitacoes/novo',
            name: 'licitacaoNovo',
            component: LicitacaoNovo,
            meta: {
                inserindo: true,
                page: {
                    title: 'Licitação',
                    subtitle: 'Novo'
                },
                authorities: ['Licitacao.Atualizar']
            }
        },
        {
            path: '/licitacoes/:id',
            name: 'licitacao',
            component: LicitacaoAtualizacao,
            redirect: '/licitacoes/:id/dadosGerais',
            children: [
                {
                    path: 'dadosGerais',
                    name: 'licitacaoAtualizacaoDadosGerais',
                    component: LicitacaoAtualizacaoDadosGerais,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Dados da Licitação'
                        }
                    }
                },
                {
                    path: 'eventosPosPublicacao',
                    name: 'licitacaoAtualizacaoEventosPosPublicacao',
                    component: TimelineEventosPosPublicacao,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Alterações Após Publicação'
                        }
                    }
                },
                {
                    path: 'edital',
                    name: 'licitacaoAtualizacaoEdital',
                    component: LicitacaoAtualizacaoEdital,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Dados do Edital'
                        }
                    }
                },
                {
                    path: 'lotesItens',
                    name: 'licitacaoAtualizacaoLotesItens',
                    component: LicitacaoAtualizacaoLotesItens,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Itens'
                        }
                    }
                },
                {
                    path: 'esclarecimentoImpugnacao',
                    name: 'licitacaoAtualizacaoEsclarecimentoImpugnacao',
                    component: LicitacaoEsclarecimentoImpugnacao,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Esclarecimento e Impugnação'
                        }
                    }
                },
                {
                    path: 'atualizacaoRecursoContrarrazao',
                    name: 'licitacaoAtualizacaoRecursoContrarrazao',
                    component: LicitacaoRecursoContrarrazao,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Recurso/Contrarrazão'
                        }
                    }
                }
            ]
        },
        {
            path: '/licitacoes/:id/proposta',
            name: 'licitacaoFornecedor',
            component: LicitacaoFornecedor,
            redirect: '/licitacoes/:id/proposta/dadosGerais',
            children: [
                {
                    path: 'dadosGerais',
                    name: 'licitacaoFornecedorDadosGerais',
                    component: LicitacaoFornecedorDadosGerais,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Dados da Licitação'
                        }
                    }
                },
                {
                    path: 'edital',
                    name: 'licitacaoFornecedorEdital',
                    component: LicitacaoFornecedorEdital,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Dados do Edital'
                        }
                    }
                },
                {
                    path: 'lotesItens',
                    name: 'licitacaoFornecedorItens',
                    component: LicitacaoFornecedorItens,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Itens'
                        }
                    }
                },
                {
                    path: 'propostaInicial',
                    name: 'licitacaoFornecedorProposta',
                    component: LicitacaoFornecedorProposta,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Proposta'
                        }
                    }
                },
                {
                    path: 'habilitacao',
                    name: 'licitacaoFornecedorDocumentos',
                    component: LicitacaoFornecedorDocumentos,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Documentos de Habilitação'
                        }
                    }
                },
                {
                    path: 'readequacao',
                    name: 'licitacaoFornecedorReadequacaoProposta',
                    component: LicitacaoFornecedorReadequacaoProposta,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Minhas Propostas'
                        }
                    }
                },
                {
                    path: 'esclarecimentoImpugnacao',
                    name: 'licitacaoFornecedorEsclarecimentoImpugnacao',
                    component: LicitacaoFornecedorEsclarecimentoImpugnacao,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Esclarecimento e Impugnação'
                        }
                    }
                },
                {
                    path: 'fornecedorRecursoContrarrazao',
                    name: 'licitacaoFornecedorRecursoContrarrazao',
                    component: LicitacaoRecursoContrarrazao,
                    meta: {
                        page: {
                            title: 'Licitação',
                            subtitle: 'Recurso/Contrarrazão'
                        }
                    }
                }
            ]
        },
        {
            path: '/comissoes',
            name: 'comissoesBuscaVisualizacao',
            component: ComissaoBusca,
            meta: {
                menu: {
                    title: 'Comissões',
                    icon: 'group'
                },
                page: {
                    title: 'Comissões',
                    subtitle: 'Lista geral das Comissões'
                },
                authorities: ['Licitacao.Atualizar']
            }
        },
        {
            path: '/comissoes/:id',
            name: 'comissaoVisualizacao',
            component: ComissaoVisualizacao,
            meta: {
                authorities: ['Licitacao.Atualizar']
            }
        },
        {
            path: '/configuracao',
            name: 'configuracao',
            component: Configuracao,
            meta: {
                menu: {
                    title: 'Configurações',
                    icon: 'settings'
                },
                authorities: ['Configuracao.Visualizar']
            },
            children: [
                {
                    path: '/configuracao/usuarios',
                    name: 'usuarioBusca',
                    component: UsuarioBusca,
                    meta: {
                        menu: {
                            title: 'Usuários',
                            icon: 'person'
                        },
                        page: {
                            title: 'Usuários',
                            subtitle: 'Lista geral dos Usuários'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/configuracao/usuarios/novo',
                    name: 'usuarioNovo',
                    component: UsuarioNovo,
                    meta: {
                        page: {
                            title: 'Usuários',
                            subtitle: 'Novo Usuário'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/configuracao/usuarios/:id',
                    name: 'usuarioDetalhe',
                    component: UsuarioDetalhe,
                    meta: {
                        page: {
                            title: 'Usuários',
                            subtitle: 'Detalhes do Usuário'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/configuracao/comissoes',
                    name: 'comissoesBusca',
                    component: ComissaoBusca,
                    meta: {
                        menu: {
                            title: 'Comissões',
                            icon: 'group'
                        },
                        page: {
                            title: 'Comissões',
                            subtitle: 'Lista geral das Comissões'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/configuracao/comissoes/novo',
                    name: 'comissaoNovo',
                    component: ComissaoNovo,
                    meta: {
                        page: {
                            title: 'Comissões',
                            subtitle: 'Nova Comissão'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/configuracao/comissoes/:id',
                    name: 'comissaoAtualizacao',
                    component: ComissaoAtualizacao,
                    meta: {
                        page: {
                            title: 'Comissões',
                            subtitle: 'Dados da Comissão'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/configuracao/termos',
                    name: 'termosConfiguracao',
                    component: TermosConfiguracao,
                    meta: {
                        menu: {
                            title: 'Termos',
                            icon: 'checklist'
                        },
                        page: {
                            title: 'Termos',
                            subtitle: 'Lista dos termos de aceite'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/configuracao/termos/novo',
                    name: 'termoNovo',
                    component: TermoNovo,
                    meta: {
                        page: {
                            title: 'Termos',
                            subtitle: 'Novo Termo'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/configuracao/termos/:id',
                    name: 'termoAtualizacao',
                    component: TermoAtualizacao,
                    meta: {
                        page: {
                            title: 'Termos',
                            subtitle: 'Dados do Termo'
                        },
                        authorities: ['Configuracao.Visualizar']
                    }
                },
                {
                    path: '/consultas/:id',
                    name: 'consultas',
                    component: Consultas,
                    redirect: '/consultas/:id/dadosLicitacao',
                    children: [
                        {
                            path: 'dadosLicitacao',
                            name: 'consultasDetalheDadosLicitacao',
                            component: ConsultasDetalhesDadosLicitacao,
                            meta: {
                                page: {
                                    title: 'Licitação Legada',
                                    subtitle: 'Dados da Licitação'
                                }
                            }
                        },
                        {
                            path: 'esclarecimentoImpugnacao',
                            name: 'consultasDetalheEsclarecimentoImpugnacao',
                            component: ConsultasDetalheEsclarecimentoImpugnacao,
                            meta: {
                                page: {
                                    title: 'Licitação Legada',
                                    subtitle: 'Esclarecimento e Impugnação'
                                }
                            }
                        },
                        {
                            path: 'documentosFornecedor',
                            name: 'consultasDetalheDocumentosFornecedor',
                            component: ConsultasDetalheDocumentosFornecedor,
                            meta: {
                                page: {
                                    title: 'Licitação Legada',
                                    subtitle: 'Documentos Fornecedor'
                                }
                            }
                        }
                    ]
                },
                {
                    path: '/manualServidor',
                    name: 'ManualLicitacaoServidor',
                    component: ManualLicitacaoServidor,
                    meta: {
                        menu: {
                            title: 'Manual',
                            icon: 'book'
                        },
                        page: {
                            title: 'Manual do Sistema',
                            subtitle: 'Manual do Servidor'
                        },
                        authorities: ['Configuracao.Visualizar'],
                    }
                },
            ]
        },
        {
            path: '/relatoriosPersonalizados',
            name: 'relatoriosPersonalizados',
            component: RelatoriosPersonalizados,
            meta: {
                menu: {
                    title: 'Relatórios',
                    icon: 'assessment'
                },
                page: {
                    title: 'Relatórios',
                    subtitle: 'Geração de relatórios personalizados'
                },
                authorities: ['Relatorio.Visualizar']
            }
        },
        {
            path: '/consultas',
            name: 'consultasListagem',
            component: ConsultasListagem,
            meta: {
                menu: {
                    title: 'Consultas',
                    icon: 'format_list_bulleted'
                },
                page: {
                    title: 'Processos Legados',
                    subtitle: 'Lista das execuções de licitação legada'
                },
            }
        },
        {
            path: '/sobre',
            name: 'Sobre',
            component: Sobre,
            meta: {
                menu: {
                    title: 'Sobre',
                    icon: 'tips_and_updates'
                },
                page: {
                    title: 'Cronos',
                    subtitle: 'cronos'
                },
                authorities: ['Sobre.Visualizar', 'Credenciamento.Visualizar', 'Licitacao.Visualizar']
            },
            children: [
                {
                    path: '/sobre/novidades',
                    name: 'novidades',
                    component: Novidades,
                    meta: {
                        menu: {
                            title: 'Novidades',
                            icon: 'newspaper'
                        },
                        page: {
                            title: 'Novidades',
                        },
                    }
                },
                {
                    path: '/sobre/roadmap',
                    name: 'roadmap',
                    component: Roadmap,
                    meta: {
                        menu: {
                            title: 'Roadmap',
                            icon: 'route'
                        },
                        page: {
                            title: 'Roadmap',
                        },
                    }
                },
                {
                    path: '/sobre/sugestoes',
                    name: 'sugestoes',
                    component: Sugestoes,
                    meta: {
                        menu: {
                            title: 'Sugestões',
                            icon: 'rate_review'
                        },
                        page: {
                            title: 'Sugestões',
                        },
                    }
                },
            ]
        },
        {
            path: '/protocolos',
            name: 'protocolos',
            component: Configuracao,
            meta: {
                menu: {
                    title: 'Protocolos',
                    icon: 'insert_drive_file'
                },
                authorities: ['Protocolos.Visualizar', 'CompararHash.Visualizar']
            },
            children: [
                {
                    path: '/protocolos/selecionarTipo',
                    name: 'protocoloSelecionar',
                    component: ProtocoloSelecionarBusca,
                    meta: {
                        menu: {
                            title: 'Protocolos',
                            icon: 'find_in_page'
                        },
                        page: {
                            title: 'Protocolos',
                            subtitle: 'Selecionar tipo documento'
                        },
                        authorities: ['Protocolos.Visualizar']
                    }
                },
                {
                    path: '/protocolos/lista/tipo=:tipo',
                    name: 'protocolosLista',
                    component: ProtocoloBusca,
                    meta: {
                        page: {
                            title: 'Protocolos',
                            subtitle: 'Lista geral de protocolos'
                        },
                        authorities: ['Protocolos.Visualizar']
                    }
                },
                {
                    path: '/protocolos/visualizar/:id/tipo=:tipo',
                    name: 'protocoloVisualizar',
                    component: ProtocoloDetalhe,
                    meta: {
                        page: {
                            title: 'Visualizar Protocolo'
                        },
                        authorities: ['Protocolos.Visualizar']
                    }
                },
                {
                    path: '/protocolos/compararHash',
                    name: 'protocoloCompararHash',
                    component: CompararHash,
                    meta: {
                        menu: {
                            title: 'Comparar Hash',
                            icon: 'compare'
                        },
                        page: {
                            title: 'Comparar Hash'
                        },
                        authorities: ['CompararHash.Visualizar']
                    }
                }
            ]
        },
        {
            path: '/esclarecimento-convidado',
            name: 'esclarecimento-convidado',
            component: LicitacaoEsclarecimentoUsuarioConvidado,
            meta: {
                page: {
                    title: 'Esclarecimentos Convidados a Responder',
                    subtitle: 'Listagem'
                }
            }
        },
        {
            path: '/impugnacao-convidado',
            name: 'impugnacao-convidado',
            component: LicitacaoImpugnacaoUsuarioConvidado,
            meta: {
                page: {
                    title: 'Impugnações Convidadas a Responder',
                    subtitle: 'Listagem'
                }
            }
        },
        {
            path: '/minhasLicitacoes',
            name: 'minhasLicitacoes',
            component: MinhasLicitacoes,
            meta: {
                menu: {
                    title: 'Minhas Licitações',
                    icon: 'dashboard'
                },
                page: {
                    title: 'Minhas Licitações',
                    subtitle: 'Listagem'
                },
                authorities: ['Proposta.Atualizar']
            }
        },
        {
            path: '/manualLicitante',
            name: 'ManualLicitacaoLicitante',
            component: ManualLicitacaoLicitante,
            meta: {
                menu: {
                    title: 'Manual',
                    icon: 'book'
                },
                page: {
                    title: 'Manual do Sistema',
                    subtitle: 'Manual do Licitante'
                },
                authorities: ['Proposta.Atualizar']
            }
        },
        {
            path: '/compraDireta',
            name: 'RedirecionarCompraDireta',
            meta: {
                menu: {
                    title: 'Compra Direta',
                    icon: 'shopping_cart'
                },
                authorities: ['Menu.CompraDireta']
            }
        },
        {
            path: '/licitacoes/:id/documentosVirtualizacao',
            name: 'documentosVirtualizacao',
            component: DocumentosVirtualizacao,
            meta: {
                page: {
                    title: 'Licitação',
                    subtitle: 'Documentos do Processo Digital'
                },
            }
        },
        {
            path: '/credenciamento/:id/documentosVirtualizacao',
            name: 'credenciamentoDocumentosVirtualizacao',
            component: CredenciamentoDocumentosVirtualizacao,
            meta: {
                page: {
                    title: 'Credenciamento',
                    subtitle: 'Documentos do Processo Digital'
                },
            }
        },
        {
            path: '/licitacoes/:id/desentranharDocumento/:documentoVirtualizadoId',
            name: 'desentranhamento',
            component: Desentranhamento,
            meta: {
                page: {
                    title: 'Documentos',
                    subtitle: 'Desentranhar documento'
                },
            }
        },
        {
            path: '/licitacoes/:id/Edocs',
            name: 'edocs',
            component: Edocs,
            meta: {
                page: {
                    title: 'Edocs',
                    subtitle: 'Edocs'
                },
            }
        },
        {
            path: '/credenciamento/:id/desentranharDocumento/:documentoVirtualizadoId',
            name: 'credenciamentoDesentranhamento',
            component: CredenciamentoDesentranhamento,
            meta: {
                page: {
                    title: 'Documentos',
                    subtitle: 'Desentranhar documento'
                },
            }
        },
        {
            path: '/configurar-integracao-ipm',
            name: 'integracaoIPM',
            component: IntegracaoIPM,
            meta: {
                page: {
                    title: 'Integração com IPM',
                    subtitle: 'Prefeituras',
                },
            }
        },
        {
            path: '/situacao-integracoes',
            name: 'SituacaoIntegracoes',
            component: SituacaoIntegracoes,
            meta: {
                page: {
                    title: 'Situação Integrações',
                    subtitle: 'Listagem de informações',
                },
            }
        },
        //credenciamento
        {
            path: '/credenciamento/:id',
            name: 'credenciamento',
            component: CredenciamentoAtualizacao,
            redirect: '/credenciamento/:id/dadosGerais',
            children: [
                {
                    path: 'analiseDocumentacao/:idAnaliseSolicitacao/solicitacao/:idSolicitacao',
                    name: 'AnaliseDocumentacaoCredenciamento',
                    component: AnaliseDocumentacaoCredenciamento
                },
                {
                    path: 'dadosGerais',
                    name: 'CredenciamentoAtualizacaoDadosGerais',
                    component: CredenciamentoAtualizacaoDadosGerais,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Dados Gerais'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'eventosPosPublicacao',
                    name: 'CredenciamentoTimelineEventosPosPublicacao',
                    component: CredenciamentoTimelineEventosPosPublicacao,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Alterações Após Publicação'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'edital',
                    name: 'CredenciamentoAtualizacaoEdital',
                    component: CredenciamentoAtualizacaoEdital,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Edital'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'lotesItens',
                    name: 'CredenciamentoAtualizacaoLotesItens',
                    component: CredenciamentoAtualizacaoLotesItens,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Itens'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'esclarecimentoImpugnacao',
                    name: 'CredenciamentoEsclarecimentoImpugnacao',
                    component: CredenciamentoEsclarecimentoImpugnacao,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Esclarecimento e Impugnação'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'execucao',
                    name: 'CredenciamentoExecucao',
                    component: CredenciamentoExecucao,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Execução'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'execucao/analise-contratacao/:demandaId',
                    name: 'AnaliseDemandaCredenciamento',
                    component: AnaliseDemandaCredenciamento,
                    meta: {
                        hidden: true,
                        ocultarNotificacoes: true
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'atualizacaoRecursoContrarrazao',
                    name: 'CredenciamentoRecursoContrarrazao',
                    component: CredenciamentoRecursoContrarrazao,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Recurso/Contrarrazão'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'participantes',
                    name: 'CredenciamentoAtualizacaoSelecaoParticipantes',
                    component: CredenciamentoAtualizacaoSelecaoParticipantes,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Seleção Participantes'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                }
            ]
        },

        {
            path: '/credenciamento/:id/proposta',
            name: 'credenciamentoFornecedor',
            component: CredenciamentoFornecedor,
            redirect: '/credenciamento/:id/proposta/dadosGerais',
            children: [
                {
                    path: 'dadosGerais',
                    name: 'credenciamentoFornecedorDadosGerais',
                    component: CredenciamentoFornecedorDadosGerais,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Dados Gerais'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'edital',
                    name: 'credenciamentoFornecedorEdital',
                    component: CredenciamentoFornecedorEdital,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Edital'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'lotesItens',
                    name: 'credenciamentoFornecedorItens',
                    component: CredenciamentoFornecedorItens,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Itens'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'propostaInicial',
                    name: 'credenciamentoFornecedorProposta',
                    component: CredenciamentoFornecedorProposta,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Proposta'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'documentos',
                    name: 'credenciamentoFornecedorDocumentos',
                    component: CredenciamentoFornecedorDocumentos,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Documentos do Credenciamento'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'esclarecimentoImpugnacao',
                    name: 'credenciamentoFornecedorEsclarecimentoImpugnacao',
                    component: CredenciamentoFornecedorEsclarecimentoImpugnacao,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Esclarecimento e Impugnação'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'fornecedorRecursoContrarrazao',
                    name: 'credenciamentoFornecedorRecursoContrarrazao',
                    component: CredenciamentoRecursoContrarrazao,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Recurso/Contrarrazão'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'Resultado',
                    name: 'CredenciamentoFornecedorResultado',
                    component: CredenciamentoFornecedorResultado,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Resultado'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'execucao',
                    name: 'CredenciamentoExecucaoFornecedor',
                    component: CredenciamentoExecucaoFornecedor,
                    meta: {
                        page: {
                            title: 'Credenciamento',
                            subtitle: 'Execução do Fornecedor'
                        }
                    },
                    authorities: ['Credenciamento.Visualizar']
                },
                {
                    path: 'execucao/analise-contratacao/:demandaId',
                    name: 'AnaliseDemandaCredenciamentoFornecedor',
                    component: AnaliseDemandaCredenciamentoFornecedor,
                    meta: {
                        hidden: true,
                        ocultarNotificacoes: true
                    },
                    authorities: ['Credenciamento.Visualizar']
                }
            ]
        },
        {
            path: '/licitacoes/:id/ocorrencia-envio-remessa',
            name: 'ocorrenciaEnvioRemessa',
            component: LicitacaoAtualizacaoAcoesOcorrenciasEnviar,
            meta: {
                page: {
                    title: 'Ocorrência Envio de Remessa',
                }
            },
        },
        {
            path: '/licitacoes/:id/ocorrencia-protocolo',
            name: 'ocorrenciaProtocolo',
            component: LicitacaoAtualizacaoAcoesOcorrenciasProtocolo,
            meta: {
                page: {
                    title: 'Protocolo',
                }
            },
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.name === 'RedirecionarCompraDireta') {
        window.open(store.state.linkCompraDireta, '_target')
        next({name: from.name})
        return
    }
    next()
})

router.beforeEach((to, from, next) => guards.condicoes(to, from, next))


export default router
